import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-circulares',
  templateUrl: './circulares.component.html',
  styleUrls: ['./circulares.component.css']
})
export class CircularesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
